import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";

import Header from "../../Theme/Header";
import Footer from "../../Theme/Footer";
import SideBar from "../../Theme/SideBar";
import { Container, Content } from "./styles";

const PrivateRoute = ({ component: Component, path, ...props }) => {
  const isAuthenticated = localStorage.getItem("token") && true;

  const render = (props) =>
    isAuthenticated ? (
      <Container>
        <Header />
        <SideBar />
        <Content>
          <Component {...props} />
        </Content>
        <Footer />
      </Container>
    ) : (
      (window.location = "/#/login")
    );

  return <Route path={path} render={render} {...props} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};

export default PrivateRoute;
